import { render, staticRenderFns } from "./MessageLine.vue?vue&type=template&id=994ae86a&scoped=true&"
import script from "./MessageLine.vue?vue&type=script&lang=js&"
export * from "./MessageLine.vue?vue&type=script&lang=js&"
import style0 from "./MessageLine.vue?vue&type=style&index=0&id=994ae86a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994ae86a",
  null
  
)

export default component.exports